import { render } from "./ServicesActivity.vue?vue&type=template&id=24af2654&scoped=true"
import script from "./ServicesActivity.vue?vue&type=script&lang=js"
export * from "./ServicesActivity.vue?vue&type=script&lang=js"

import "./ServicesActivity.vue?vue&type=style&index=0&id=24af2654&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24af2654"]])

export default __exports__